/**
 * BackLink: the breadcrumb "back to the list" of a detail page, a real router link (no href="#").
 * Props: `to` (route of the list), `children` (the translated label).
 */
import { Breadcrumb, BreadcrumbItem } from '@carbon/react';
import { ArrowLeft } from '@carbon/icons-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

export function BackLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Breadcrumb noTrailingSlash>
      <BreadcrumbItem>
        <Link to={to}>
          <ArrowLeft size={16} /> {children}
        </Link>
      </BreadcrumbItem>
    </Breadcrumb>
  );
}
